import {
  Component, ChangeDetectionStrategy, Input, ViewChild, TemplateRef,
} from '@angular/core'

/**
 * Control IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
let _uniqueIdCounter = 0

@Component({
  selector: 'kb-tab-panel',
  templateUrl: './tab-panel.component.html',
  styleUrls: ['./tab-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class TabPanelComponent {
  @Input()
  public headingLevel?: 2 | 3 | 4 | 'none'

  private readonly uniqueId = `${_uniqueIdCounter++}`
  public readonly headerId = `kb-tab-panel-header-${this.uniqueId}`
  public readonly contentId = `kb-tab-panel-content-${this.uniqueId}`

  @ViewChild('headerTemplate', { static: true }) public readonly header!: TemplateRef<unknown>
  @ViewChild('contentTemplate', { static: true }) public readonly content!: TemplateRef<unknown>
}
